/**
 * Bundle selector: Afterpay init and size guide click handler.
 * Loaded with the bundle-selector block.
 */
(function () {
  'use strict';

  function initAfterpay() {
    var container = document.querySelector('.bundle-selector__afterpay[data-afterpay-amount]');
    if (!container) return;

    var amount = parseInt(container.getAttribute('data-afterpay-amount'), 10) || 0;
    var apConfig = {
      priceSelector: '.bundle-selector__afterpay',
      amount: amount,
      locale: 'en_US',
      currency: 'USD',
      giftCard: false,
      minMaxThreshold: { min: 3500, max: 100000 }
    };

    function runInit() {
      if (typeof presentAfterpay !== 'undefined' && container) {
        new presentAfterpay(apConfig).init();
      } else {
        setTimeout(runInit, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit);
    } else {
      runInit();
    }
  }

  function initSizeGuide() {
    if (window.__bundleSizeGuideClickBound) return;
    window.__bundleSizeGuideClickBound = true;

    function findModalNearButton(button, dialogId) {
      var bundler = button.closest('product-bundler');
      if (bundler) {
        var modal = bundler.querySelector('[id="' + dialogId + '"]');
        if (modal) return modal;
      }
      return document.getElementById(dialogId);
    }

    document.addEventListener('click', function (e) {
      var sizeGuideButton = e.target.closest('[data-action="size-guide"]');
      if (!sizeGuideButton) return;

      e.preventDefault();
      e.stopPropagation();
      var modal = findModalNearButton(sizeGuideButton, 'size-guide-dialog');
      if (modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
      }
    });
  }

  function init() {
    initSizeGuide();
    var afterpayContainer = document.querySelector('.bundle-selector__afterpay[data-afterpay-amount]');
    if (afterpayContainer) {
      var apScript = document.createElement('script');
      apScript.async = true;
      apScript.src = 'https://static-us.afterpay.com/javascript/present-afterpay.js';
      apScript.onload = initAfterpay;
      document.head.appendChild(apScript);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
